import { Item } from '../lib/api';
import { SwipeCard } from './SwipeCard';

interface SwipeCardProfileProps {
  item: Item;
  onSwipe: (direction: 'left' | 'right') => void;
  onInfo: () => void;
}

export function SwipeCardProfile({ item, onSwipe, onInfo }: SwipeCardProfileProps) {
  return (
    <SwipeCard item={item} onSwipe={onSwipe} onInfo={onInfo} variant="profile" />
  );
}
